import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import country from 'country-list-js';
import { FaTrashAlt } from "react-icons/fa";
import { motion } from "framer-motion";
import { registerExpert } from "../../services/api";
import Loader from "../Loader";
import { toast } from "react-toastify";


function ExpertForm() {
  const initialState = { 
    firstName: '', 
    lastName: '', 
    name: '', 
    email: '', 
    phone: '', 
    password: "", 
    conf_pass: "", 
    country: "", 
    profile_link: "",
    job_record: [null],
    availability: '', 
    hourly_fee: "",
    currency: "",
    experience: ""  
  };
  const [data, setData] = React.useState(initialState);
  const [formMsg, setFormMsg] = useState(null);
  const [loading, setLoading] = useState(false);
  const [countries, setCountries] = useState([]);

  const [experiences, setExperiences] = useState([
    { company: "", title: "", start: "", end: "", isPresent: false }
  ]);

  const handleAddExperience = () => {
    setExperiences([
      ...experiences,
      { company: "", title: "", start: "", end: "", isPresent: false },
    ]);
  };

  const handleRemoveExperience = (index) => {
    setExperiences(experiences.filter((_, i) => i !== index));
  };

  const handleExpInputChange = (index, field, value) => {
    const newExperiences = experiences.map((exp, i) =>
      i === index ? { ...exp, [field]: value } : exp
    );
    setExperiences(newExperiences);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = data;
    formData.job_record = JSON.stringify(experiences);
    formData.name = data.firstName + " "+ data.lastName;

    try {
      setLoading(true);
      const response = await registerExpert(formData);

      if(response.success){
        console.log('res', response);
        toast.success(response.msg);
        setLoading(false);

        setTimeout(() => {
          setFormMsg(null);
          setData(initialState);
        }, 2000);
      }
    }
    catch(err) {
      console.log("Error", err);
      if(err.response && err.status == 422) {
        toast.error(err.response.data.errors[0].message);
      } else {
        toast.error(err.message);
      }
      setLoading(false);
    }

  };

  useEffect(() => {
    const country_names = country.names();
    setCountries(country_names);
  },[]);
  return (
    <motion.section
      initial={{ opacity: 0, scale: 0.5 }}
      whileInView={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5, delay: 0.5, type: "spring" }}
      viewport={{ once: true }} 
      className="flex justify-center items-center py-8 mt-8 w-full max-md:px-5 max-md:mt-5 max-md:max-w-full lg:mb-32 max-md:mb-16"
      id="become-expert-form"
    >
      <form
        className="flex flex-col self-stretch px-5 w-full md:max-w-[950px] form"
        onSubmit={(e) => handleSubmit(e)}
      >
        <div className="self-center text-2xl sm:text-5xl font-medium text-center light-title">
          Expert Registration
        </div>

        <div className="mt-8 w-full max-md:max-w-full">
          <div className="flex gap-5 max-md:flex-col max-md:gap-0">
            <div className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
              <div className="text-lg font-medium text-color max-md:mt-8">
                First Name
              </div>
              <input
                type="text"
                placeholder=""
                name="firstName"
                className="box-border flex relative flex-col shrink-0 p-2.5 mt-5 rounded-md border-2 border-solid"
                required
                value={data.firstName}
                onChange={(e) => setData(prev => ({ ...prev, "firstName": e.target.value }))}
              />
            </div>
            <div className="flex flex-col ml-5 w-6/12 max-md:ml-0 max-md:w-full">
              <div className="flex flex-col grow max-md:mt-8">
                <div className="text-lg font-medium text-color">Last Name</div>
                <input
                  type="text"
                  placeholder=""
                  name="lastName"
                  className="box-border flex relative flex-col shrink-0 p-2.5 mt-5 rounded-md border-2 border-solid"
                  required
                  value={data.lastName}
                  onChange={(e) => setData(prev => ({ ...prev, "lastName": e.target.value }))}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mt-8 w-full max-md:max-w-full max-sm:mt-0">
          <div className="flex gap-5 max-md:flex-col max-md:gap-0">
            <div className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
              <div className="flex flex-col grow text-lg font-medium text-color whitespace-nowrap max-md:mt-8">
                <div>Email</div>
                <input
                  type="email"
                  placeholder=""
                  name="email"
                  className="box-border flex relative flex-col shrink-0 p-2.5 mt-5 rounded-md border-2 border-solid"
                  required
                  value={data.email}
                  onChange={(e) => setData(prev => ({ ...prev, "email": e.target.value }))}
                />
              </div>
            </div>
            <div className="flex flex-col ml-5 w-6/12 max-md:ml-0 max-md:w-full">
              <div className="flex flex-col grow text-lg font-medium text-color max-md:mt-8">
                <div>Contact Number</div>
                <PhoneInput
                  className="box-border flex relative flex-col shrink-0 p-1.5 mt-5 rounded-md border-2 border-solid"
                  inputStyle={{ borderStyle: "none", width: "inherit" }}
                  dropdownStyle={{
                    borderStyle: "solid",
                    border: 1,
                    borderColor: "#6369C4",
                    backgroundColor: "#fff",
                  }}
                  buttonStyle={{
                    borderStyle: "none",
                    border: 0,
                    backgroundColor: "#fff",
                  }}
                  required
                  country={"us"}
                  value={data.phone}
                  onChange={(ph) => setData(prev => ({ ...prev, "phone": ph }))}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 w-full max-md:max-w-full">
          <div className="flex gap-5 max-md:flex-col max-md:gap-0">
            <div className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
              <div className="text-lg font-medium text-color max-md:mt-8">
                Password
              </div>
              <input
                type="text"
                placeholder=""
                name="password"
                className="box-border flex relative flex-col shrink-0 p-2.5 mt-5 rounded-md border-2 border-solid"
                required
                value={data.password}
                onChange={(e) => setData(prev => ({ ...prev, "password": e.target.value }))}
              />
            </div>
            <div className="flex flex-col ml-5 w-6/12 max-md:ml-0 max-md:w-full">
              <div className="flex flex-col grow max-md:mt-8">
                <div className="text-lg font-medium text-color">Confirm Password</div>
                <input
                  type="text"
                  placeholder=""
                  name="conf_pass"
                  className="box-border flex relative flex-col shrink-0 p-2.5 mt-5 rounded-md border-2 border-solid"
                  required
                  value={data.conf_pass}
                  onChange={(e) => setData(prev => ({ ...prev, "conf_pass": e.target.value }))}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 w-full max-md:max-w-full">
          <div className="flex gap-5 max-md:flex-col max-md:gap-0">
            <div className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
              <div className="flex flex-col grow text-lg font-medium text-color whitespace-nowrap max-md:mt-8">
                <div>Country</div>
                <select
                  type="text"
                  placeholder=""
                  name="country"
                  className="box-border flex relative flex-col shrink-0 p-2.5 mt-5 rounded-md border-2 border-solid"
                  required
                  value={data.country}
                  onChange={(e) => setData(prev => ({ ...prev, "country": e.target.value }))}
                >
                  <option value="">Select Country</option>
                  {
                    countries.map(cn => {
                      return (
                        <option value={cn}>{ cn }</option>
                      )
                    })
                  }
                </select>
              </div>
            </div>

            <div className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
              <div className="flex flex-col grow text-lg font-medium text-color whitespace-nowrap max-md:mt-8">
                <div>Profile Link</div>
                <input
                  type="text"
                  placeholder=""
                  name="profile_link"
                  className="box-border flex relative flex-col shrink-0 p-2.5 mt-5 rounded-md border-2 border-solid"
                  required
                  value={data.profile_link}
                  onChange={(e) => setData(prev => ({ ...prev, "profile_link": e.target.value }))}
                />
              </div>
            </div>
          </div>
        </div>

        <fieldset className="border-2 border-slate-50 rounded-md px-2 py-3 my-3">
          <legend className="bg-dark-indigo text-white p-2 text-sm">Job Record</legend>

          <button className="bg-indigo-200 text-indigo-600 p-2 rounded-md cursor-pointer text-right text-sm" onClick={handleAddExperience}>Add New Record</button>

          {experiences.map((experience, index) => (
            <div key={index} className="flex flex-col sm:flex-row space-x-2 mb-2">
              <input
                type="text"
                placeholder="Company"
                className="box-border flex relative flex-col shrink-0 p-2.5 mt-5 rounded-md border-2 border-solid"
                required
                value={experience.company}
                onChange={(e) =>
                  handleExpInputChange(index, "company", e.target.value)
                }
              />

              <input
                type="text"
                placeholder="Title"
                className="box-border flex relative flex-col shrink-0 p-2.5 mt-5 rounded-md border-2 border-solid"
                required
                value={experience.title}
                onChange={(e) => handleExpInputChange(index, "title", e.target.value)}
              />

              <input
                type="date"
                placeholder="Start Date"
                className="box-border flex relative flex-col shrink-0 p-2.5 mt-5 rounded-md border-2 border-solid"
                required
                value={experience.start}
                onChange={(e) => handleExpInputChange(index, "start", e.target.value)}
              />

              <input
                type="date"
                placeholder="End Date"
                className="box-border flex relative flex-col shrink-0 p-2.5 mt-5 rounded-md border-2 border-solid"
                disabled={experience.isPresent}
                value={experience.end}
                onChange={(e) => handleExpInputChange(index, "end", e.target.value)}
              />

            <div className="flex items-center space-x-3 mt-2.5">
              <input
                type="checkbox"
                className="box-border p-2 rounded-md border-2 border-solid"
                checked={experience.isPresent}
                onChange={(e) =>
                  handleExpInputChange(index, "isPresent", e.target.checked)
                }
              />
              <label htmlFor="present" className="text-sm">
                Present
              </label>
            </div>

            <span className="flex items-center">
              <button
                className="text-red-700 mt-2"
                onClick={() => handleRemoveExperience(index)}
              >
                <FaTrashAlt size={20} />
              </button>
            </span>
           </div>
          ))}
        </fieldset>

        <fieldset className="border-2 border-slate-50 rounded-md px-2 py-3 my-3">
          <legend className="bg-dark-indigo text-white p-2 text-sm">Project Data</legend>

          <div className="mt-8 w-full max-md:max-w-full">
            <div className="flex gap-5 max-md:flex-col max-md:gap-0">
              <div className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
                <div className="text-lg font-medium text-color max-md:mt-8">
                  Availability
                </div>
                <input
                  type="text"
                  placeholder=""
                  name="availability"
                  className="box-border flex relative flex-col shrink-0 p-2.5 my-2 rounded-md border-2 border-solid"
                  required
                  value={data.availability}
                  onChange={(e) => setData(prev => ({ ...prev, "availability": e.target.value }))}
                />
              </div>

              <div className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
                <div className="text-lg font-medium text-color max-md:mt-8">
                  Hourly Fee
                </div>
                <input
                  type="text"
                  placeholder=""
                  name="hourly_fee"
                  className="box-border flex relative flex-col shrink-0 p-2.5 my-2 rounded-md border-2 border-solid"
                  required
                  value={data.hourly_fee}
                  onChange={(e) => setData(prev => ({ ...prev, "hourly_fee": e.target.value }))}
                />
              </div>

              <div className="flex flex-col ml-5 w-6/12 max-md:ml-0 max-md:w-full">
                <div className="flex flex-col grow max-md:mt-8">
                  <div className="text-lg font-medium text-color">
                    Currency
                  </div>
                  <input
                    type="text"
                    placeholder=""
                    name="currency"
                    className="box-border flex relative flex-col shrink-0 p-2.5 my-2 rounded-md border-2 border-solid"
                    required
                    value={data.currency}
                    onChange={(e) => setData(prev => ({ ...prev, "currency": e.target.value }))}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="mt-8 w-full text-lg font-medium text-color max-md:mt-10 max-md:max-w-full max-sm:mt-8">
            Experience
          </div>
          <textarea
            name="experience"
            className="w-full box-border flex relative flex-col shrink-0 px-2.5 pt-2.5 pb-28 my-2 rounded-md border-2 border-solid"
            required
            value={data.experience}
            onChange={(e) => setData(prev => ({ ...prev, "experience": e.target.value }))}
          />
        </fieldset>

        <button className="justify-center items-center self-center px-4 py-3 my-8 max-w-full text-2xl font-medium text-center dark-button text-white whitespace-nowrap rounded-lg  shadow-xl w-[300px] max-md:px-5">
          { loading ? <Loader />: "Submit" }
        </button>
      </form>
    </motion.section>
  );
}

export default ExpertForm;
